import React from 'react';
import { founders } from '../mock';
import { Sparkles } from 'lucide-react';
import FounderCard from './FounderCard';

const VARIANTS = ['red', 'teal'];

export default function Founders() {
  return (
    <section id="founders" className="py-16 lg:py-24 bg-[#FFF8EC] relative overflow-hidden">
      <div className="absolute inset-0 grid-dots opacity-40 pointer-events-none" />
      <div className="max-w-7xl mx-auto px-5 lg:px-8 relative">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <span className="inline-flex items-center gap-2 text-[#E64B2B] uppercase tracking-[0.25em] font-black text-xs bg-white px-4 py-1.5 rounded-full border-2 border-[#2C3E50]">
            <Sparkles size={12} /> Meet the founders
          </span>
          <h2 className="mt-4 text-3xl lg:text-5xl font-black text-[#2C3E50] leading-[1.05]">
            The teachers behind the <span className="text-[#4FB3B8]">teachers.</span>
          </h2>
          <p className="mt-4 text-[#2C3E50]/75 text-lg">
            Two educators on a mission to make personalised, high-quality tuition accessible to every family in India.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {founders.map((f, i) => (
            <FounderCard key={f.name} founder={f} variant={VARIANTS[i % VARIANTS.length]} />
          ))}
        </div>

        <div className="mt-12 text-center">
          <blockquote
            className="max-w-3xl mx-auto text-xl lg:text-2xl text-[#2C3E50] font-semibold italic leading-relaxed"
            style={{ fontFamily: 'Fraunces, serif' }}
          >
            &ldquo;Every child deserves a mentor who sees them &mdash; not just their marks. That&rsquo;s the school we&rsquo;re trying to build, one home at a time.&rdquo;
          </blockquote>
          <div className="mt-4 text-sm font-black uppercase tracking-[0.25em] text-[#4FB3B8]">
            &mdash; Team Pikachu Classes
          </div>
        </div>
      </div>
    </section>
  );
}
